import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { columnData, ColumnData } from "../../data/columnData";
import "./NotionStyle.css";

const ColumnPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const column: ColumnData | undefined = columnData.find(
    (col) => col.slug === slug,
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!column) {
    return (
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-4">컬럼을 찾을 수 없습니다.</h1>
        <p>요청하신 컬럼 페이지를 찾을 수 없습니다.</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 pt-48 pb-8">
      <article className="max-w-3xl mx-auto">
        <h1 className="text-5xl font-extrabold mb-4 leading-tight text-gray-900">
          {column.title}
        </h1>
        <h2 className="text-xl font-medium mb-8 text-gray-600">
          {column.subtitle}
        </h2>
        <div className="flex items-center text-sm text-gray-500 mb-12 border-b pb-8">
          <span className="font-semibold text-gray-900 mr-2">{column.author}</span>
          <span className="mx-2">|</span>
          <span>{new Date(column.date).toLocaleDateString()}</span>
        </div>
        <div 
          className="notion-style" 
          dangerouslySetInnerHTML={{ __html: column.htmlContent }} 
        />
      </article>
    </div>
  );
};

export default ColumnPage;
